 <div class="casePnlBox">
      <div class="case-header">
        <h3 >
          <img alt="entity" src="../../../../assets/icons/automation-coocon-icon.svg" /> Automations
        </h3>
        <div class="refreshIcon">
          <i class="fa fa-refresh view-details" (click)="refreshAutomationList()"></i>
        </div>
      </div>
      <div class="case-content">
        <div class="chatCnt chatScrollContant" [style.height.px]="containerHeight + 350" >
          <div class="createBtnInner mb-3" *ngFor="let data of automationDataList">
            <button (click)="getAutomation(data)">
              <img alt="entity" src="../../../../assets/icons/automation_sml.svg" />
              <ob-ng-tooltip [data]="data.businessActivityName" [size]="30"></ob-ng-tooltip>
            </button>
          </div>
          <div class="mb-3">
            <div class="mainWhiteBoxPading noPaddingZero marginBtmCaseDetail">
              <div class="card styleTableCT noPaddingBorder" *ngFor="let job of Jobs">
                <div class="automation-card">
                  <div class="automation-header">
                    <h4 class="automation-name">{{ job.jobName }}</h4>
                    <span class="automation-status" [ngClass]="getStatusClass(job.jobStatus)">
                      {{ job.jobStatus }}
                    </span>
                  </div>
                  <div class="automation-details">
                    <div class="detail-row">
                      <span class="detail-label">Start Time:</span>
                      <span class="detail-value">{{ job.displayStartTime }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">End Time:</span>
                      <span class="detail-value">{{ job.displayEndTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="Jobs.length === 0" class="no-automations">
                No Automations found
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>